import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  AiOutlineShoppingCart,
  AiOutlinePlus,
  AiOutlineMinus,
} from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import {
  addToCart,
  incrementQuantity,
  decrementQuantity,
} from "../redux/features/cartSlice";
import { buildSrcSet } from "../utils/imageUrl";

const ProductCard = ({ id, title, image, weight, onImageClick = () => {} }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [cartCount, setCartCount] = useState(0);

  // Get the item from Redux store
  const cartItem = useSelector((state) =>
    state.cart.cartItems.find((item) => item.id === id),
  );

  // console.log('cartItem',cartItem);

  // Handle Add to Cart
  const handleAddToCart = (e) => {
    e.stopPropagation();
    setCartCount(1); // Add item and start with 1 quantity
  };

  // Increase item count
  const incrementCount = (e) => {
    e.stopPropagation();
    setCartCount(cartCount + 1);
  };

  // Decrease item count or remove if 0
  const decrementCount = (e) => {
    e.stopPropagation();
    if (cartCount > 1) {
      setCartCount(cartCount - 1);
    } else {
      setCartCount(0); // Remove from cart
    }
  };

  const navigateToProductDetails = () => {
    navigate("productdetails", {
      state: {
        productID: id,
      },
    });
  };

  return (
    <div className="col-span-12 md:col-span-6 lg:col-span-3 bg-white shadow-md mb-6">
      {/* Product Image */}
      <div className="bg-[#FDFBF7] w-full h-44 flex items-center justify-center overflow-hidden rounded-t-lg">
        <img
          src={image}
          srcSet={buildSrcSet(image) || undefined}
          sizes="(min-width: 1024px) 320px, (min-width: 768px) 46vw, 92vw"
          alt={title}
          loading="lazy"
          decoding="async"
          onClick={() => onImageClick(image)}
          className="w-full h-full  object-center transform hover:scale-105 transition duration-300 cursor-pointer"
        />
      </div>

      <div className="px-2.5 py-1.5">
        <div
          className="flex items-start justify-between"
          onClick={() => navigateToProductDetails()}
        >
          <div>
            <h3 className="text-xs font-semibold text-gray-800">{title}</h3>
            {weight && (
              <p className="text-gray-600 text-xs">Weight: {weight}</p>
            )}
          </div>
          {weight && cartItem?.quantity > 0 && (
            <div className="text-right">
              <p className="text-gray-600 text-xs">Total Weight</p>
              <p className="text-gray-600 text-sm font-medium">
                {(parseFloat(weight) * (cartItem?.quantity || 0)).toFixed(3)} gm
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Product Details & Cart Button */}
      <div className="px-2.5 pb-2.5 rounded-b-lg">
        {!cartItem ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              dispatch(addToCart({ id, title, image, weight }));
            }}
            className="w-full bg-[#AD826D] hover:bg-[#9C7260] text-white py-2.5 px-4 rounded-lg font-medium text-sm transition-colors"
          >
            ADD TO CART
          </button>
        ) : (
          <div className="flex items-center justify-center space-x-2 border rounded-full">
            <button
              onClick={() => dispatch(decrementQuantity({ id }))}
              className="text-dark px-3 py-1.5 rounded-full"
            >
              −
            </button>
            <span className="text-sm font-bold w-8 text-center">
              {cartItem.quantity}
            </span>
            <button
              onClick={() => dispatch(incrementQuantity({ id }))}
              className="text-dark px-3 py-1.5 rounded-full"
            >
              +
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
